import MUITableCell, { TableCellProps } from "@material-ui/core/TableCell";

const TableCell = (props: TableCellProps) => <MUITableCell {...props} />;

export default TableCell;
